export default __webpack_public_path__ + "static/media/menu_link_user_selected.b09226ff.svg";